import { IoIosAnalytics } from 'react-icons/io';
import { FaRegClock } from 'react-icons/fa';
import { AiOutlineCloudDownload } from 'react-icons/ai';
import { IoMdWifi } from 'react-icons/io';
import img1 from "../../../../assets/img/Services/IotEdgeSolution/2150663451.jpg";

export default function MainSection1() {
  return (
    
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
       <div className="flex flex-col mb-6 justify-center lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-lg mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">Our Offerings</span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
          
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Edge Infrastructure Deployment
            </h1>
            <p className="text-lg text-gray-600">
            Deploy edge servers and gateways to process data closer to devices for faster decision-making.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineCloudDownload className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Reduced Latency</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Deploy edge servers and gateways to process data locally, minimizing delays and enabling real-time decision-making.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoMdWifi className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Optimized Bandwidth Usage</h3>
              </div>
              <p className="text-gray-600 text-sm">
              By processing data closer to the devices, reduce the amount of data sent to the cloud, improving bandwidth efficiency and lowering operational costs.
              </p>
            </div>

           
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}